import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import TasksView from '../components/contents/TasksViewNew';

const TasksPage = () => {
    // Установка заголовка для страницы предписаний
    useEffect(() => {
        document.title = "Задачи";
    }, []);

    return (
        <Box sx={{
            display: 'flex',
            flex: 1,
            height: '100%',
            flexDirection: 'column',
            overflow: 'hidden',
            width: '100%'
        }}>
            <TasksView
                isModal={false}
                onClose={null}
                map={null}
                fromStartPage={true}
            />
        </Box>
    );
};

export default TasksPage; 